/* Pre-order (Indy 14-10). Voorbeeldstand: ?preorder=voorbeeld toont de pre-orderweergave zonder de voorraad te veranderen.
   Alleen weergave: in de voorbeeldstand gaat er niets extra's mee naar de winkelwagen. */
(() => {
  let demo = false;
  try { demo = new URLSearchParams(location.search).get('preorder') === 'voorbeeld'; } catch (e) {}
  if (!demo) return;
  const zet = () => {
    document.querySelectorAll('[data-po-voorbeeld]').forEach((e) => { e.hidden = false; });
    document.querySelectorAll('[data-po-verberg]').forEach((e) => { e.hidden = true; });
  };
  zet();
  document.addEventListener('DOMContentLoaded', zet);
})();
function amIsPreorder() { return !!document.querySelector('.am-preorder:not([hidden]):not(.am-preorder--soldout)'); }

/* Avondmakers redesign: losse scripts die op elke pagina nodig zijn */

/* Pijltjes bij de upsell in het winkelwagenpaneel. Via de document gekoppeld,
   want het paneel wordt na elke toevoeging opnieuw ingeladen (scripts daarin draaien niet). */
    (() => {
      const update = () => document.querySelectorAll('.am-upsell').forEach((u) => {
        const t = u.querySelector('.am-upsell__track'); if (!t || t.clientWidth === 0) return; /* paneel dicht: niets meten */
        const [prev, next] = u.querySelectorAll('.am-upsell__arrow');
        const max = t.scrollWidth - t.clientWidth - 2;
        if (prev) prev.disabled = t.scrollLeft <= 2;
        if (next) next.disabled = t.scrollLeft >= max;
        u.classList.toggle('am-upsell--single', max <= 0);
      });
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.am-upsell__arrow'); if (!btn) return;
        const t = btn.closest('.am-upsell').querySelector('.am-upsell__track');
        const item = t.querySelector('.am-upsell__item');
        t.scrollBy({ left: (item ? item.getBoundingClientRect().width + 10 : t.clientWidth) * Number(btn.dataset.dir), behavior: 'smooth' });
      });
      document.addEventListener('scroll', (e) => { if (e.target.classList && e.target.classList.contains('am-upsell__track')) update(); }, true);
      new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('transitionend', update, true);
      window.addEventListener('resize', update);
      update();
    })();


/* Schuifrijen op de homepage (Onze Spellen, Bundelkortingen): pijltjes + uitgrijzen aan begin en eind */
(() => {
  const update = (slider) => {
    const t = slider.querySelector('.am-slider__track'); if (!t) return;
    const max = t.scrollWidth - t.clientWidth - 2;
    const [prev, next] = [slider.querySelector('[data-dir="-1"]'), slider.querySelector('[data-dir="1"]')];
    if (prev) prev.disabled = t.scrollLeft <= 2;
    if (next) next.disabled = t.scrollLeft >= max;
    const media = t.querySelector('.am-card__media');
    if (media) slider.style.setProperty('--am-arrow-top', (media.getBoundingClientRect().top - slider.getBoundingClientRect().top + media.offsetHeight / 2) + 'px');
  };
  const all = () => document.querySelectorAll('.am-slider').forEach(update);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.am-slider__arrow'); if (!btn) return;
    const slider = btn.closest('.am-slider'); const t = slider.querySelector('.am-slider__track');
    const card = t.querySelector('.am-card');
    t.scrollBy({ left: (card ? card.getBoundingClientRect().width + 20 : t.clientWidth) * Number(btn.dataset.dir), behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => { const s = e.target.closest && e.target.closest('.am-slider'); if (s) update(s); }, true);
  window.addEventListener('resize', all);
  window.addEventListener('load', all);
  document.addEventListener('DOMContentLoaded', all);
})();

/* "Combineer en bespaar" op de productpagina: spellen aanvinken, live prijs, alles in één keer toevoegen */
if (!customElements.get('am-combo')) {
  customElements.define('am-combo', class extends HTMLElement {
    connectedCallback() {
      this.tiers = (this.dataset.tiers || '').split(',').map(Number);
      this.vtiers = (this.dataset.vtiers || '').split(',').map(Number);
      this.fmt = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
      this.eur = (c) => (Math.abs(c - Math.round(c / 100) * 100) <= 5 ? '€' + Math.round(c / 100) : this.fmt(c));
      this.order = [];
      this.addEventListener('change', (e) => {
        const i = e.target; if (!i.matches('input[type=checkbox]')) return;
        this.order = this.order.filter((x) => x !== i);
        if (i.checked) this.order.push(i);
        this.update();
      });
      this.querySelector('[data-submit]').addEventListener('click', () => this.add());
      this.update();
    }
    selected() { return [...this.querySelectorAll('input[type=checkbox]')].filter((i) => i.checked); }
    /* Korting voor een set: gewone staffel over de 4 spellen, of de Virals-staffel over alle 5 (Shopify kiest de hoogste) */
    disc(set) {
      const t = (arr, k) => arr[Math.min(k, arr.length - 1)] || 0;
      const games = set.filter((i) => !i.dataset.virals).length;
      return Math.max(t(this.tiers, games), t(this.vtiers, set.length));
    }
    update() {
      const sel = this.selected(); const n = sel.length;
      const sum = sel.reduce((a, i) => a + Number(i.dataset.price), 0);
      const disc = this.disc(sel);
      const self = this.querySelector('.am-combo__item.is-self input');
      const open = [...this.querySelectorAll('.am-combo__item:not(.is-self) input')].filter((i) => !i.checked);
      const next = open.reduce((m, i) => Math.max(m, this.disc([...sel, i])), 0);
      this.querySelector('[data-count]').textContent = n === 1 ? '1 spel' : n + ' spellen';
      const was = this.querySelector('[data-was]'); was.hidden = disc === 0; was.textContent = this.fmt(sum);
      this.querySelector('[data-now]').textContent = this.fmt(sum - disc);
      /* Levert één spel erbij nog niets op (Virals telt niet mee), kijk dan naar twee spellen erbij */
      let next2 = 0;
      if (next === 0) open.forEach((a, i) => open.slice(i + 1).forEach((b2) => { next2 = Math.max(next2, this.disc([...sel, a, b2])); }));
      this.querySelector('[data-save]').textContent = disc > 0
        ? 'Je bespaart ' + this.eur(disc) + (next > disc ? ' · nog een spel erbij: ' + this.eur(next) + ' korting' : '')
        : next > 0 ? 'Kies nog een spel en krijg ' + this.eur(next) + ' korting'
        : next2 > 0 ? 'Kies nog 2 spellen en krijg ' + this.eur(next2) + ' korting' : '';
      this.querySelector('[data-save]').classList.toggle('is-saving', disc > 0);
      this.querySelector('[data-label]').textContent = n === 1 ? (amIsPreorder() ? 'Pre-order nu' : 'In winkelwagen') : 'Voeg ' + n + ' spellen toe';
      /* Prijs per spel: een gekozen spel krijgt de korting die het toevoegde (in de volgorde van aanvinken); niet-gekozen spellen tonen de prijs als volgende keuze */
      const chain = [self, ...this.order];
      this.querySelectorAll('.am-combo__item:not(.is-self) input').forEach((i) => {
        let off;
        if (i.checked) { const k = chain.indexOf(i); off = this.disc(chain.slice(0, k + 1)) - this.disc(chain.slice(0, k)); }
        else off = this.disc([...sel, i]) - disc;
        const row = i.closest('.am-combo__item');
        const was = row.querySelector('[data-item-was]'), now = row.querySelector('[data-item-now]');
        was.hidden = off <= 0; now.textContent = this.fmt(Number(i.dataset.price) - off);
        now.classList.toggle('is-deal', off > 0);
      });
      /* Pre-order (Indy 14-10): is dit spel in pre-order, dan bij de andere spellen 'Direct verzonden' en een regel over de levering */
      const selfPre = amIsPreorder();
      this.querySelectorAll('[data-po-direct]').forEach((e) => { e.hidden = !selfPre; });
      const split = this.querySelector('[data-po-split]'); if (split) split.hidden = !(selfPre && n > 1);
      this.querySelectorAll('.am-combo__tiers li').forEach((li) => li.classList.toggle('is-active', disc > 0 && Number(li.dataset.amount) === disc));
    }
    async add() {
      const btn = this.querySelector('[data-submit]'); if (btn.disabled) return;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
        const items = this.selected().map((i) => (i.dataset.levering ? { id: Number(i.dataset.variant), quantity: 1, properties: { Levering: i.dataset.levering } } : { id: Number(i.dataset.variant), quantity: 1 }));
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items, sections, sections_url: window.location.pathname }) });
        const parsed = await res.json();
        if (parsed.status) { alert(parsed.description || 'Toevoegen lukte niet'); return; }
        const cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
        cart.sections = parsed.sections;
        if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart });
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.show) drawer.show(btn); else window.location.href = window.Shopify.routes.root + 'cart';
      } catch (e) { console.error(e); }
      finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });
}

/* Zwevende winkelwagenknop op productpagina's. Telefoon: zichtbaar tot de echte knop in beeld komt. Desktop: zichtbaar zolang de echte knop niet in beeld is (Indy 08-10) */
document.addEventListener('DOMContentLoaded', () => {
  const info = document.querySelector('.product__info');
  if (!info) return;
  const combo = info.querySelector('am-combo');
  const target = combo ? combo.querySelector('[data-submit]') : info.querySelector('.product-form__submit');
  if (!target) return;
  const priceEl = combo ? combo.querySelector('[data-now]') : info.querySelector('.price__regular');
  const wrap = document.createElement('div');
  wrap.className = 'am-float-cart';
  wrap.innerHTML = '<button type="button" class="am-btn"><span>' + (amIsPreorder() ? 'Pre-order nu' : 'In winkelwagen') + '</span><span class="am-float-cart__price"></span></button>';
  document.body.appendChild(wrap);
  const btn = wrap.querySelector('button'), price = wrap.querySelector('.am-float-cart__price');
  const sync = () => { if (priceEl) price.textContent = '· ' + priceEl.textContent.trim(); };
  sync(); if (combo) combo.addEventListener('change', () => setTimeout(sync, 0));
  btn.addEventListener('click', () => { if (combo && combo.add) combo.add(); else target.click(); });
  const mobile = window.matchMedia('(max-width: 767px)');
  new IntersectionObserver(([e]) => {
    /* verbergen zodra de echte knop in beeld is; op de telefoon ook als je er al voorbij bent */
    const passed = mobile.matches && e.boundingClientRect.top < 0;
    wrap.classList.toggle('is-hidden', e.isIntersecting || passed);
  }, { threshold: 0.2 }).observe(target);
});
